import React, { useState } from 'react';
import logo from "../images/logo.png";
import { Lock, Eye, EyeOff } from 'lucide-react';
import AutoCadastroService from '../../modules/services/AutoCadastroService';
import '../css/login.css';

const SENHA_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[*.+():_=\-@#!$])[A-Za-z\d*.+():_=\-@#!$]{6,15}$/;
const REGRA_SENHA = 'A senha deve ter entre 6 e 15 caracteres, com ao menos uma letra maiúscula, uma minúscula, um número e um caractere especial (*.+():_=-@#!$).';

function RedefinirSenha() {
    const token = new URLSearchParams(window.location.search).get('token');

    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');
    const [sucesso, setSucesso] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!token) {
            setErro('Link de redefinição inválido.');
            return;
        }
        if (!SENHA_REGEX.test(novaSenha)) {
            setErro(REGRA_SENHA);
            return;
        }
        if (novaSenha !== confirmarSenha) {
            setErro('As senhas não coincidem.');
            return;
        }

        setErro('');
        setCarregando(true);
        try {
            await AutoCadastroService.redefinirSenha(token, novaSenha);
            setSucesso(true);
        } catch (error) {
            setErro(error.message || 'Não foi possível redefinir a senha.');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <main className="login-page">
            <aside className="login-brand-panel">
                <div className="login-brand-mark">
                    <span className="login-wordmark">
                       <img src={logo} alt="Logo" className="logo" />
                    </span>
                </div>
                <div className="login-brand-headline">
                    <h1>Redefinir senha.</h1>
                    <p>Escolha uma nova senha para acessar o portal.</p>
                </div>
            </aside>

            <section className="login-form-panel">
                <div className="login-form-wrap">
                    {sucesso ? (
                        <div className="login-form-header">
                            <h2>Senha redefinida!</h2>
                            <p>Você já pode entrar com a nova senha.</p>
                            <a href="/">Ir para o login</a>
                        </div>
                    ) : (
                        <>
                            <div className="login-form-header">
                                <h2>Nova senha</h2>
                                <p>{REGRA_SENHA}</p>
                            </div>

                            <form className="login-form" onSubmit={handleSubmit} noValidate>
                                <div className="login-field">
                                    <label htmlFor="nova-senha">Nova senha</label>
                                    <div className="login-input-wrap">
                                        <Lock className="login-ico-lead" size={18} />
                                        <input
                                            id="nova-senha"
                                            type={mostrarSenha ? 'text' : 'password'}
                                            value={novaSenha}
                                            onChange={(event) => setNovaSenha(event.target.value)}
                                            disabled={carregando}
                                        />
                                        <button
                                            type="button"
                                            className="login-toggle-pwd"
                                            aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                            onClick={() => setMostrarSenha((valor) => !valor)}
                                        >
                                            {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </button>
                                    </div>
                                </div>

                                <div className="login-field">
                                    <label htmlFor="confirmar-senha">Confirmar senha</label>
                                    <div className="login-input-wrap">
                                        <Lock className="login-ico-lead" size={18} />
                                        <input
                                            id="confirmar-senha"
                                            type={mostrarSenha ? 'text' : 'password'}
                                            value={confirmarSenha}
                                            onChange={(event) => setConfirmarSenha(event.target.value)}
                                            disabled={carregando}
                                        />
                                    </div>
                                </div>

                                {erro && <div className="login-erro">{erro}</div>}

                                <button type="submit" className="login-btn-submit" disabled={carregando}>
                                    {carregando ? 'Salvando...' : 'Redefinir senha'}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </section>
        </main>
    );
}

export default RedefinirSenha;
